import * as React from 'react';
import classNames from 'classnames';
import { LoaderIcon } from 'components/icons';
import './loader.styles.scss';

interface ILoaderItem {
	wrapperClass?: string;
	overlay?: boolean;
	color?: string;
}

interface ILoader {
	isLoading?: boolean;
	overlay?: boolean;
	wrapperClass?: string;
	color?: string;
}

const LoaderItem = ({ wrapperClass, overlay, color }: ILoaderItem) => (
	<div
		className={classNames('loader', wrapperClass, {
			loader__overlay: overlay,
		})}
	>
		<LoaderIcon iconClass="loader__icon" color={color} />
	</div>
);

export const Loader: React.FC<ILoader> = ({
	isLoading,
	children,
	overlay,
	wrapperClass,
	color,
}) => {
	if (isLoading) {
		return overlay ? (
			<div className={classNames('relative', wrapperClass)}>
				<>{children}</>
				<LoaderItem overlay={overlay} color={color} />
			</div>
		) : (
			<LoaderItem wrapperClass={wrapperClass} color={color} />
		);
	}

	return <>{children}</>;
};
